import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/client/Components/Alert/index.js